import {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from 'react'
import { IConsultationDetailsResponseGroup } from '../types'
import { FunctionComponentChildren } from '@/@types/react'

interface IGroupConsultationContext {
  groupConsultationData: IConsultationDetailsResponseGroup
  setGroupConsultationData: (groupConsultationData) => void
}

const GroupConsultationContext = createContext<IGroupConsultationContext>(null)

export const GroupConsultationProvider: FunctionComponentChildren = ({
  children,
}) => {
  const [groupConsultationState, setGroupConsultationState] = useState(null)

  const setGroupConsultationData = useCallback(
    (groupConsultationData: IConsultationDetailsResponseGroup) => {
      setGroupConsultationState(groupConsultationData)
    },
    [],
  )

  const values = useMemo(
    () => ({
      groupConsultationData: groupConsultationState,
      setGroupConsultationData,
    }),
    [groupConsultationState, setGroupConsultationData],
  )

  return (
    <GroupConsultationContext.Provider value={values}>
      {children}
    </GroupConsultationContext.Provider>
  )
}
export const useGroupConsultationContext = (): IGroupConsultationContext => {
  const context = useContext(GroupConsultationContext)
  if (!context) {
    throw new Error(
      'useGroupConsultationContext must be used within a GroupConsultationProvider',
    )
  }
  return context
}
